import { render } from "./TimerPage.vue?vue&type=template&id=4ba70a0c"
import script from "./TimerPage.vue?vue&type=script&lang=js"
export * from "./TimerPage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__